import { PageContext } from '@contexts/page'
import { ContentType } from '@entries/content-types'
import ContentfulCtaMain from '@entries/contentful-cta-main'
import { Entry } from '@resolvers/entry'
import React, { type FC, useContext } from 'react'

export const MainCta: FC = () => {
  const { ctaRefs } = useContext(PageContext)

  return (
    ctaRefs?.length && (
      <Entry
        content={ctaRefs[0]}
        mapping={{
          [ContentType.ContentfulCta]: ContentfulCtaMain,
        }}
      />
    )
  )
}
